import CCColors from '@/Utils/CCColors';
import React from 'react';
import {View, TouchableOpacity} from 'react-native';
import SimpleLineIcons from 'react-native-vector-icons/SimpleLineIcons';

const TimelineWithPuzzles = ({duration, progress, puzzles, onSeek}) => {
  return (
    <View style={{position: 'relative', width: '100%', paddingBottom: 10}}>
      <input
        type="range"
        min={0}
        max={1}
        step="0.01"
        value={progress}
        onChange={e => onSeek(Number(e.target.value))}
        style={{
          width: '100%',
          height: '6px',
          borderRadius: '4px',
          background: CCColors?.Grey?.Grey,
        }}
      />

      {puzzles?.map((puzzle, idx) => {
        const leftPercent = (puzzle.timestamp / duration) * 100;
        return (
          <TouchableOpacity
            key={idx}
            onPress={() => onSeek(puzzle.timestamp)}
            style={{
              position: 'absolute',
              left: `${leftPercent}%`,
              top: -30,
            }}>
            <SimpleLineIcons name="puzzle" size={20} color={CCColors.White} />
          </TouchableOpacity>
        );
      })}
    </View>
  );
};

export default TimelineWithPuzzles;
